import styled from "styled-components";
import { Row, Col } from "antd";
import { COLORS } from "../../constants/colors";

export const StyledRow = styled(Row)`
    position: fixed;
    border-radius: 17px 17px 0px 0px;
    bottom: 0;
    width: 100%;
    background: #F2F7FF;
    padding: 10px 0;
    border-top: 1px solid #e8e8e8;
    box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);
    z-index: 999;
`;

export const StyledCol = styled(Col)`
    text-align: center;
    position: relative;
    cursor: pointer;
    color: ${(props) => (props.active === "true" ? COLORS.$mainBlue : COLORS.$black)};
    &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: -1px;
        top: 15%;
        height: 70%;
        width: 1px;
        background-color: #e8e8e8;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
`;

export const IconWrapper = styled.div`
    font-size: 22px;
    margin-bottom: 5px;
    color: ${(props) => (props.active === "true" ? COLORS.$mainBlue : COLORS.$black)};
    transition: color 0.3s;
    line-height: 1.5;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonLabel = styled.div`
    font-size: 14px;
    font-weight: ${(props) => (props.bold === "true" ? '700' : '400')};
    color: ${(props) => (props.active === "true" ? COLORS.$mainBlue : COLORS.$black)};
    transition: color 0.3s;
    line-height: 1.2;
    display: flex;
    margin-bottom: 5px;
    align-items: center;
    justify-content: center;
`;

export const DashboardPopup = styled.div`
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    padding: 10px;
    z-index: 1000;
    min-width: 140px;
`;

export const PopupItem = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.2s;
    
    &:hover {
        background-color: #f0f0f0;
    }
    
    span {
        margin-left: 10px;
        font-size: 14px;
        color: ${props => props.isActive ? COLORS.$mainBlue : COLORS.$black};
    }
    
    svg {
        font-size: 16px;
        color: ${props => props.isActive ? COLORS.$mainBlue : COLORS.$black};
    }
`;